export class TargetScalingSettings {
    /**
     * Cilova zmena velikosti (1 = original, 0.5 = polovina originalu)
     */
    scale: number;
    /**
     * Prodleva pred zmenou do scale v ms
     */
    delayTo: number;
    /**
     * Delka zmeny do scale v ms
     */
    toLen: number;
    /**
     * Prodleva pred navratem do scale 1 v ms
     */
    delayFrom: number;
    /**
     * Delka zmeny ze scale do scale 1 v ms
     */
    fromLen: number;
    /**
     * Ease funkce pro zmenu smerem do scale
     */
    easeTo: (k: number) => number;
    /**
     * Ease funkce pro zmenu smerem ze scale
     */
    easeFrom: (k: number) => number;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(scale: number, delayTo: number, toLen: number, easeTo: (k: number) => number, delayFrom: number, fromLen: number, easeFrom: (k: number) => number) {
        this.scale = scale;
        this.delayTo = delayTo;
        this.toLen = toLen;
        this.easeTo = easeTo;
        this.delayFrom = delayFrom;
        this.fromLen = fromLen;
        this.easeFrom = easeFrom;
    }
}



/**
 * Vypocet velikosti terce na zaklade nastaveni TargetScalingSettings
 */
export class TargetScaler {
    private _settings: TargetScalingSettings;
    private _timeTo: number;
    private _timeFrom: number;

    get isActive(): boolean { return this._settings != null; }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor() {
        this.reset();
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    reset(): void {
        this._settings = null;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    init(settings: TargetScalingSettings): void {
        this._settings = settings;
        this._timeTo = settings.delayTo + settings.toLen;
        this._timeFrom = settings.delayFrom + settings.fromLen;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    getScale(time: number): number {
        // Cas v ramci scale
        time = time % (this._timeTo + this._timeFrom);

        // Vypocet scale
        let scale: number;

        if (time < this._timeTo) {
            if ((time -= this._settings.delayTo) <= 0)
                return 1;

            scale = this._settings.easeTo(time / this._settings.toLen);
        }
        else {
            if ((time -= (this._timeTo + this._settings.delayFrom)) <= 0)
                return this._settings.scale;

            scale = 1 - this._settings.easeFrom(time / this._settings.fromLen);
        }

        return 1 + (this._settings.scale - 1) * scale;
    }
}